import React from 'react';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { func, shape, string, bool } from 'prop-types';
import ReactCodeInput from 'react-verification-code-input';

import { DATA_TEST_ID } from '~constants/tests';
import AuthActions from '~redux/Auth/actions';
import Text from '~components/Text';

import { FIELDS } from '../../../../constants';
import styles from '../../../../styles.module.scss';
import LoginInput from '../../../LoginInput';

import stylesInput from './styles.module.scss';
import { codeQuantityFields } from './constants';

function LoginForm({ values, handleChange, codeSended, errorCode, setFieldValue }) {
  const dispatch = useDispatch();
  const handleChangeCode = (ev) => setFieldValue(FIELDS.VERIFICATION_CODE, ev);
  const handleDismissCode = () => dispatch(AuthActions.signInEmaillCodeDismiss());
  return (
    <>
      {codeSended ? (
        <>
          <input
            name={FIELDS.VERIFICATION_CODE}
            value={values[FIELDS.VERIFICATION_CODE]}
            type="text"
            hidden
            className="hide"
          />
          <div className={`text-base regular m-left-1 ${styles.label}`}>
            {i18next.t('Login:enterYourCode')}
          </div>
          <ReactCodeInput
            className={`${stylesInput.codeInput} m-top-2`}
            type="text"
            fields={codeQuantityFields}
            onChange={handleChangeCode}
          />
          {errorCode && (
            <Text
              data-testid={DATA_TEST_ID.verificationCodeError}
              className={`full-width light text-light row center m-top-2 ${styles.textError}`}>
              {i18next.t('Login:errorCode')}
            </Text>
          )}
          <Text
            onClick={handleDismissCode}
            className={`full-width light text-light row center m-top-3 ${stylesInput.retryEmail}`}>
            {i18next.t('Login:retryOtherEmail')}
          </Text>
        </>
      ) : (
        <LoginInput
          name={FIELDS.EMAIL}
          type={FIELDS.EMAIL}
          label={i18next.t('Login:enterYourEmail')}
          value={values[FIELDS.EMAIL]}
          onChange={handleChange}
        />
      )}
      <button type="submit" className={`full-width text-uppercase bold m-top-10 ${styles.button}`}>
        {i18next.t('Login:enter')}
      </button>
      {!codeSended && (
        <Text className={`full-width light text-light row center m-top-6 ${styles.text}`}>
          {i18next.t('Login:text')}
        </Text>
      )}
    </>
  );
}

LoginForm.propTypes = {
  handleChange: func.isRequired,
  codeSended: bool,
  errorCode: string,
  setFieldValue: func,
  values: shape({
    [FIELDS.EMAIL]: string
  })
};

export default LoginForm;
